// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-options-container-TjZ18 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
}

.modal-options-option_base-wXy14 {
  width: 100%;
  height: 38px;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/modal-options/modal-options.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n}\n\n.option_base {\n  width: 100%;\n  height: 38px;\n  justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal-options-container-TjZ18`,
	"option_base": `modal-options-option_base-wXy14`
};
export default ___CSS_LOADER_EXPORT___;
